export const ListTableColgroup = () => {
  return (
    <colgroup>
      <col width="88px" />
      <col width="200px" />
      <col />
      <col width="132px" />
    </colgroup>
  );
};